<template>
    <div class="sidebar leading-none">
        <div class="sidebar-content">
            <ul class="nav-sidebar" data-nav-type="accordion">
                <li class="px-5 mt-3"> 
                    <div class="text-xs uppercase text-gray-500 py-3">main</div>
                </li>
                <li class="nav-item">
                    <router-link @click.native="onBreadcrumb('Dashboard')" to="/" class="nav-link" exact>
                        <i class="icon-grid5 mr-5"></i>
                        <span>Dashboard</span>
                    </router-link>
                </li>
                <!--  -->
                <!-- Absensi -->
                <li id="absensi" class="nav-item">
                    <router-link @click.native="onBreadcrumb('Absensi')" to="/absensi" class="nav-link">
                        <i class="icon-clipboard2 mr-4.5"></i>
                        <span>Absensi</span>
                    </router-link>
                </li>
                <!-- Suppliers -->
                <!-- <li id="suppliers" class="nav-item">
                    <router-link @click.native="onBreadcrumb('Suppliers')" to="/suppliers" class="nav-link">
                        <i class="icon-users2 mr-4.5"></i>
                        <span>Suppliers</span>
                    </router-link>
                </li> -->
                <!-- /suppliers -->

                <!-- Products -->
                <li id="products" class="nav-item nav-item-submenu">
                    <a href="#" class="nav-link">
                        <i class="icon-stack2 mr-4.5"></i>
                        <span>Products</span>
                    </a>
                    <ul class="nav-group-sub">
                        <li class="nav-item">
                            <router-link @click.native="onBreadcrumb('Products')" to="/products" class="nav-link">
                                <div class="bg-gray-800 rounded h-6 w-6 mr-5 flex items-center justify-center">IM</div>
                                <span>Items</span>
                            </router-link>
                        </li>
                    </ul>
                </li>
                <!-- /products -->
                <!-- ingredients -->
                <li id="ingredients" class="nav-item nav-item-submenu">
                    <a href="#" class="nav-link">
                        <i class="icon-make-group mr-4.5"></i>
                        <span>Ingredients</span>
                    </a>
                    <ul class="nav-group-sub">
                        <li class="nav-item">
                            <router-link @click.native="onBreadcrumb('Ingredients')" to="/ingredients" class="nav-link">
                                <div class="bg-gray-800 rounded h-6 w-6 mr-5 flex items-center justify-center">IL</div>
                                <span>Ingredient Library</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link @click.native="onBreadcrumb('Recipes')" to="/receipes" class="nav-link">
                                <div class="bg-gray-800 rounded h-6 w-6 mr-5 flex items-center justify-center">RC</div>
                                <span>Recipes</span>
                            </router-link>
                        </li>
                    </ul>
                </li>
                <!-- /ingredients -->
                <!-- inventory -->
                <li id="inventory" class="nav-item nav-item-submenu">
                    <a href="#" class="nav-link">
                        <i class="icon-server mr-4.5"></i>
                        <span>Inventory</span>
                    </a>
                    <ul class="nav-group-sub">
                        <li class="nav-item">
                            <router-link @click.native="onBreadcrumb('Summary Ingredients')" to="/summary-ingredients" class="nav-link">
                                <div class="bg-gray-800 rounded h-6 w-6 mr-5 flex items-center justify-center">SI</div>
                                <span>Summary Ingredients</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link @click.native="onBreadcrumb('Summary Items')" to="/summary-items" class="nav-link">
                                <div class="bg-gray-800 rounded h-6 w-6 mr-5 flex items-center justify-center">SI</div>
                                <span>Summary Items</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link @click.native="onBreadcrumb('Suppliers')" to="/suppliers" class="nav-link">
                                <div class="bg-gray-800 rounded h-6 w-6 mr-5 flex items-center justify-center">SP</div>
                                <span>Suppliers</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link @click.native="onBreadcrumb('Purchasing Order')" to="/purchasing" class="nav-link">
                                <div class="bg-gray-800 rounded h-6 w-6 mr-5 flex items-center justify-center">PO</div>
                                <span>Purchasing Order</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link @click.native="onBreadcrumb('Transfer')" to="/transfer" class="nav-link">
                                <div class="bg-gray-800 rounded h-6 w-6 mr-5 flex items-center justify-center">TF</div>
                                <span>Transfer</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link @click.native="onBreadcrumb('Adjustment')" to="/adjustment" class="nav-link">
                                <div class="bg-gray-800 rounded h-6 w-6 mr-5 flex items-center justify-center">AJ</div>
                                <span>Adjustment</span>
                            </router-link>
                        </li>
                    </ul>
                </li>
                <!-- /inventory -->
                <li class="px-5"> 
                    <div class="text-xs uppercase text-gray-500 py-3">operations</div>
                </li>
                <li id="penjualan" class="nav-item">
                    <router-link @click.native="onBreadcrumb('Penjualan')" to="/sales" class="nav-link">
                        <i class="icon-store mr-4.5"></i>
                        <span>Penjualan</span>
                    </router-link>
                </li>
                <li id="report" class="nav-item">
                    <router-link @click.native="onBreadcrumb('Report')" to="/report" class="nav-link">
                        <i class="icon-file-spreadsheet mr-4.5"></i>
                        <span>Report</span>
                    </router-link>
                </li>
                <!-- Purchases -->
                <!-- <li id="purchases" class="nav-item nav-item-submenu">
                    <a href="#" class="nav-link">
                        <i class="icon-stack mr-5"></i>
                        <span>Purchases</span>
                    </a>
                    <ul class="nav-group-sub">
                        <li class="nav-item">
                            <router-link @click.native="onBreadcrumb('Purchase Orders')" to="/purchases" class="nav-link">
                                <span class="bg-gray-800 rounded h-6 w-6 flex items-center justify-center mr-5">PO</span>
                                <span>Purchase Orders</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <a href="#" class="nav-link">
                                <span class="bg-gray-800 rounded h-6 w-6 flex items-center justify-center mr-5">SO</span>
                                <span>Receive Notes</span>
                            </a>
                        </li>
                    </ul>
                </li> -->
                <!-- Purchases -->
            </ul>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import BreadcrumbsManager from '../mixins/breadcrumbsManager.vue'
import {mapGetters} from 'vuex'

export default {
    mixins: [BreadcrumbsManager],
    mounted () {
            this.navigasi()
            this.activeNav()
    },
    computed: {
        ...mapGetters({
            user: 'auth/user'
        }),
        route () {
            return this.$route.path
        },
        absensi () {
            return /\/absensi.*/.test(this.route)
        },
        products () {
            return /\/products.*/.test(this.route)
        },
        ingredients () {
            return /\/ingredients.*/.test(this.route)
        },
        receipes () {
            return /\/receipes.*/.test(this.route)
        },
        summary_ingredinets () {
            return /\/summary-ingredient.*/.test(this.route)
        },
        summary_items () {
            return /\/summary-items.*/.test(this.route)
        },
        suppliers () {
            return /\/suppliers.*/.test(this.route)
        },
        purchasing () {
            return /\/purchasing.*/.test(this.route)
        },
        transfer () {
            return /\/transfer.*/.test(this.route)
        },
        adjustment () {
            return /\/adjustment.*/.test(this.route)
        },
        penjualan () {
            return /\/sales.*/.test(this.route)
        },
        report () {
            return /\/report.*/.test(this.route)
        }
    },
    methods: {
        onBreadcrumb (val) {
            this.setBreadcrumbs([
                {text: val}
            ])
        },
        navigasi() {
            $('.nav-sidebar').each(function () {
                $(this).find('.nav-item').has('.nav-group-sub').children('.nav-item > .nav-link').on('click', function(e) {
                    e.preventDefault()
                    var $target = $(this)
                    if($target.parent('.nav-item').hasClass('nav-item-open')) {
                        $target.parent('.nav-item').removeClass('nav-item-open').children('.nav-group-sub').slideUp(250)
                    } else {
                        $target.parent('.nav-item').addClass('nav-item-open').children('.nav-group-sub').slideDown(250)
                    }
                })
                $(this).find('.nav-item').children('.nav-item > .nav-link').on('click', function(e) {
                    e.preventDefault()
                    // accordion
                    if($(this).parent('.nav-item')) {
                        $(this).parent('.nav-item').siblings(':has(.nav-group-sub)').removeClass('nav-item-open').children('.nav-group-sub').slideUp(250)
                    }
                })
            }) 
        },
        closMenu (id) {
            $('.nav-sidebar').each(function() {
                $(this).find('.nav-item').not(id).removeClass('nav-item-open').children('.nav-group-sub').slideUp(250)
            })
        },
        activeNav () {
            if(!this.products && !this.absensi && !this.ingredients && !this.receipes 
            && !this.summary_ingredinets && !this.summary_items && !this.suppliers && !this.purchasing && !this.transfer && !this.adjustment
            && !this.penjualan && !this.report) {
                $('.nav-sidebar').each(function() {
                    $(this).find('.nav-item').removeClass('nav-item-open').children('.nav-group-sub').slideUp(250)
                })
            }
            if(this.absensi) {
                $('#absensi').addClass('nav-item-open').children('.nav-group-sub').slideDown(250)
                this.closMenu('#absensi')
            } 
            if(this.products) {
                $('#products').addClass('nav-item-open').children('.nav-group-sub').slideDown(250)
                this.closMenu('#products')
            } 
            if(this.ingredients) {
                $('#ingredients').addClass('nav-item-open').children('.nav-group-sub').slideDown(250)
                this.closMenu('#ingredients')
            }
            if(this.receipes) {
                $('#ingredients').addClass('nav-item-open').children('.nav-group-sub').slideDown(250)
                this.closMenu('#ingredients')
            }
            if(this.summary_ingredinets) {
                $('#inventory').addClass('nav-item-open').children('.nav-group-sub').slideDown(250)
                this.closMenu('#inventory')
            }
            if(this.summary_items) {
                $('#inventory').addClass('nav-item-open').children('.nav-group-sub').slideDown(250)
                this.closMenu('#inventory')
            }
            if(this.suppliers) {
                $('#inventory').addClass('nav-item-open').children('.nav-group-sub').slideDown(250)
                this.closMenu('#inventory')
            }
            if(this.purchasing) {
                $('#inventory').addClass('nav-item-open').children('.nav-group-sub').slideDown(250)
                this.closMenu('#inventory')
            }
            if(this.transfer) {
                $('#inventory').addClass('nav-item-open').children('.nav-group-sub').slideDown(250)
                this.closMenu('#inventory')
            }
            if(this.adjustment) {
                $('#inventory').addClass('nav-item-open').children('.nav-group-sub').slideDown(250)
                this.closMenu('#inventory')
            }
            if(this.penjualan) {
                $('#penjualan').addClass('nav-item-open').children('.nav-group-sub').slideDown(250)
                this.closMenu('#penjualan')
            }
            if(this.report) {
                $('#report').addClass('nav-item-open').children('.nav-group-sub').slideDown(250)
                this.closMenu('#penjualan')
            }
        }
    },
    watch: {
        user(val) {
            if(val) {
                if(val.role != 'admin') {
                    $('#purchases').addClass('hidden')
                    $('#suppliers').addClass('hidden')
                    $('#bank').addClass('hidden')
                } else {
                    $('#purchases').removeClass('hidden')
                    $('#suppliers').removeClass('hidden')
                    $('#bank').removeClass('hidden')
                }
            }
        },
        $route() {
            this.activeNav()
        }
    },
}
</script>